import { createAction, props } from '@ngrx/store';
import { IImage } from 'src/models/image.model';
import { EntityActions } from '../entity.actions';

export const fromImageActions = {
	...EntityActions.create<IImage>('[Image]'),
	loadImage: createAction(`[Image] Load Image`, props<{ id: string }>()),
	loadedImages: createAction(`[Image] Loaded Images`, props<{ images: IImage[] }>()),
};
